import { OrganisersIcon } from 'components/ProductSidebar/ProductGroupNav/ProductGroupNavSVGs';
import { ProductGroup } from 'rangeConfig/@types';
import selectedMenu from './selectedMenu';
import mainMenu from './mainMenu';

const organisers = (): ProductGroup => {
  return {
    id: 'organisers-knoxhult',
    productTypes: [],
    icon: OrganisersIcon,
    mainMenu,
    selectedMenu
  };
};

export default organisers;
